export default __webpack_public_path__ + "static/media/iphone-14.0a0174c8.jpg";